import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzI18nService, en_US } from 'ng-zorro-antd/i18n';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { RadioButtonModule } from 'primeng/radiobutton';
import { Table, TableModule } from 'primeng/table';
import { TableRowActionsModel, ButtonConfig, ColumnType, FilterRuleType, FilterType, ListConfigData, ListGridRequestPayload, RefrralHeaderType, SearchParams } from '../../interfaces/list.interface';
import { ErrorAlertService } from '../../services/error-alert.service';
import { ListService } from '../../services/list.service';
import { SharedDataService } from '../../services/shared-data-service';
import { ActionsComponent } from '../actions/actions.component';
import { ButtonComponent } from "../button/button.component";
import { PopupDialogComponent } from "../popup-dialog/popup-dialog.component";
import { GridAction } from './grid-action.model';
import { listablecongfig } from './listable-constant';
import { NgZorroModule } from '../../modules/ng-zorro/ng-zorro.module';
import { NzAriaLabelDirective } from '../../directives/nz-aria-label.directive';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { BooleanYesNoPipe } from "../../pipes/boolean-yes-no.pipe";
import { TimeFormatPipe } from '../../pipes/time-convertion.pipe';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NewlineToBrPipe } from '../../pipes/new-line-to-br';
import { UserService } from '../../../services/user.service';
import { NotificationSMSComponent } from '../../modals/notification-sms/notification-sms.component';
import CommonUtil from '../../authorization/common.util';
import { DropdownSelectComponent } from '../dropdown-select/dropdown-select.component';
import { PPLRadioFocusDirective } from '../../directives/ppl-radio-focus.directive';

@Component({
  selector: 'ppl-list-table',
  standalone: true,
  providers: [ListService],
  imports: [TableModule, CommonModule, ReactiveFormsModule, FormsModule, RadioButtonModule, ButtonModule, NgZorroModule, ActionsComponent, DropdownSelectComponent,
    NotificationSMSComponent, ButtonComponent, PopupDialogComponent, IconFieldModule, InputIconModule, NzAriaLabelDirective, BooleanYesNoPipe, TimeFormatPipe, NewlineToBrPipe, NzPopoverModule, NzButtonModule, PPLRadioFocusDirective],
  templateUrl: './list-table.component.html',
  styleUrl: './list-table.component.css'
})
export class ListTableComponent implements OnInit, OnChanges {


  @ViewChild('inputRef') inputRef!: ElementRef;
  @ViewChild('dt2') dt!: Table;
  @Input() showCustomSearch = true;
  @Input() data: any[] = [];
  @Input() cols: ColumnType[] = [];
  @Input() lineItemCols: ColumnType[] = [];
  @Input() globalFilterField: any[] = [];
  @Input() disableSort = false;
  @Input() disableSearch = false;
  @Input() disableSelection = false;
  @Input() enableActions = false;
  @Input() enablePageActions = false;
  @Input() showSelectAction = true;
  @Input() showExpandIcon = false;
  @Input() buttonConfig: any;
  /**
   * For lazy loading pagination, loadPage = true
   * For eager loading pagination, loadPage = false, rowsToDisplay = x, pagination = true
   */
  @Input() pagination = true;
  @Input() rowsToDisplay = 5;
  @Input() loadPage = true;
  @Input() jsonList = '';
  @Input() sharedDataKey = '';
  @Input() columnsToBeHidden: string[] = [];
  @Input() actionsToBeHidden: string[] = [];
  @Input() isVerifiedFlag = false;
  @Input() searchDropdownValues: any;
  @Input() searchDropdownValuesByColumn: { [column: string]: any[] } = {};

  @Input() actionButtons: TableRowActionsModel | null | undefined = null;
  public panelWidth = 1024;
  protected filterTypes: FilterType[] = [];
  button: any[] = [];
  @Input() pageTitle: string | undefined;
  @Input() gridTitle = true;
  @Input() showLineItem = false;
  @Input() showLineItemActions = true;
  @Input() pageConfig = "";
  @Input() from = "";
  @Input() customDataLoaded: boolean = false;
  @Output() gridAction = new EventEmitter<GridAction>();
  @Output() rowDetailEvent = new EventEmitter<any>();
  @Output() onPageLoad = new EventEmitter<any>();
  @Output() rowDetailEventTs = new EventEmitter<any>();
  @Output() showAuthDetails = new EventEmitter<any>();
  @Output() actionInvoked = new EventEmitter<any>();
  @Output() selectionChanged: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() isProvider?: boolean = false;
  @Input() tableWidth: any;
  @Input() tableScrollable = true;
  @Input() tableScrollHeight?: string = undefined;
  @Input() additionalCols?: any;
  @Input() timesheetFor?: string = 'staff';
  @Input() listButton: ButtonConfig[] = [];
  @Input() selectionDisabler?: (row: any) => boolean;
  itemData: any;

  // What field from the listData / rowData primarily identifies it? eg. id, provider-ppl-id, tracking_number, etc.
  @Input() rowDataAccessibilityKey = '';

  protected globalFilterColumns: any[] = [];
  protected filterRules: FilterRuleType[] = []
  protected listData: any[] = [];
  protected filteredData: any[] = [];
  protected restoreHeaderData: RefrralHeaderType[] = [];
  protected countdisplay_N = 0;
  protected isApplyBtnVisible = false;
  protected globalFilterfield: string[] = [];
  protected totalRecords = 0;
  protected pageSize: number = listablecongfig.pageSize;
  protected intialLoad = true;
  protected pagesLoaded = 0;
  protected sortByOptions: FilterType[] = listablecongfig.sortByOptions;
  protected sortBy!: string;
  protected columnName!: string;
  protected columnsDropdownOptions!: any[];
  protected lastLoadedPage = 0;
  protected isBackwardNavigation = false;
  private nextRefreshPage = 1;
  private recordsPerPage = 20;
  private currentUIPage = 1;
  selectedRow: any[] = [];
  protected condition = 'and';
  protected conditionType: FilterType[] = listablecongfig.conditonType;
  protected listConfigData!: ListConfigData;
  protected filterHeaders: RefrralHeaderType[] = [];
  isVisible = false;
  title = '';
  okText = '';
  placeholder = '';
  isAssignToUser = false;
  listOfOption: string[] = [];
  gridTextSearchFilter: any = '';
  gridSearchData: any[] = [];
  isFilterApplied = false;
  selectedColumnFilters: Record<number, string> = {};
  isLoadedDataFromSharedService = false;
  selectedCheckBoxValue: any[] = [];
  showSMSModal: any = '';
  selectedProgram !: any;
  notificationType: any;
  filterError: any;
  showSortByError: boolean = false;
  show = false;
  parentUrlSubscription: Subscription = new Subscription();
  isCreationFlow: boolean = false;
  first = 0;
  @Input() highlightFirst?: boolean = true;
  @Input() boldFirstRow?: boolean = false;
  lastClickedCol: any = null;
  paystubActionType: any;

  constructor(private listService: ListService, private changeDetectRef: ChangeDetectorRef,
    private i18n: NzI18nService, private sharedDataService: SharedDataService,
    private userService: UserService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {

    this.selectedProgram = this.userService.getSelectedProgram();
    if (this.data) {
      console.log(this.from, 'columns', this.cols);
      if (this.data.length) {
        console.log(this.from, 'data', this.data);
      }
      this.init();
    }

    const appliedFilters = this.sharedDataService.getData(this.sharedDataKey);
    if (this.sharedDataKey && appliedFilters) {
      this.isLoadedDataFromSharedService = true;
      this.reloadDataFromSharedService(appliedFilters);
    } else {
      this.addRule();
    }

    if (this.route.parent) {
      this.parentUrlSubscription = this.route.parent.url.subscribe(data => this.isCreationFlow = data[0].path === 'newReferral');
    }

    this.filterRules.forEach(rule => {
      rule.disableValue = false;
    });
  }

  ngOnDestory() {
    this.parentUrlSubscription.unsubscribe();
  }

  setPanelWidth() {
    const inputWidth = this.inputRef?.nativeElement?.offsetWidth;
    this.panelWidth = inputWidth;

  }

  onSelectionChange() {
    this.selectionChanged.emit(this.selectedCheckBoxValue);
  }

  leadUpdated(event: any) {
    if (event) {
      const payload = this.buildRequestPayload();
      this.refetchDataAfterUpdate(payload);
      this.selectedCheckBoxValue = [];
      this.gridTextSearchFilter = '';
      this.first = 0;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pageConfig']) {
      this.initHeader();
    }
    if (changes['data']) { // refresh grid when the external data input changes
      this.refreshGridData();
      this.changeDetectRef.detectChanges();
    }
    if (changes['rowsToDisplay']) {
      this.pageSize = this.rowsToDisplay;
    }
  }

  isPaginationVisible() {
    if (this.pagination) {
      return true
    }
    if (this.gridTextSearchFilter.length > 0 && this.gridSearchData.length > this.pageSize) {
      return true
    }
    if (this.gridTextSearchFilter.length == 0 && this.listData.length > this.pageSize) {
      return true;
    }
    return false;
  }

  init() {
    this.filteredData = [...this.data];
    this.globalFilterColumns = this.setGlobalFilterColumn();
  }

  refreshGridData() {
    this.filteredData = this.data ? [...this.data] : [];
  }

  isClickableInBilling(rowData: any, field: string): boolean {
    const val = rowData[field];
    return (
      ['batchFileId', 'batchName', 'ngAppConfigId', 'lkpDomainId', 'lkpValueId', 'fileId'].includes(field) ||
      // Consumer Ledger grid only (rows there carry claimFamilyId) - PPL ICN opens that
      // claim's ledger; Claim ID itself is plain text.
      (field === 'pplIcn' && rowData?.claimFamilyId !== undefined) ||
      ((field === 'ignoredTimesheetCount') && val) ||
      (field === 'resubFlg' && val === 'Yes')
    );
  }

  isClickableInReport(rowData: any, field: string): boolean {
    return (
      ['ignoreReason', 'mcoName'].includes(field)
    );
  }

  setGlobalFilterColumn() {
    if (this.data[0]) {
      const dataKeys: any[] = Object.keys(this.data![0]);
      const columnValues = dataKeys?.map((key: string) => {
        return { label: key.charAt(0).toUpperCase() + key.slice(1).toLowerCase(), value: key }
      })
      return columnValues;
    }
    else {
      return [];
    }

  }

  initHeader() {
    if (!this.jsonList) {
      return;
    }
    this.listConfigData = this.listService.getListConfigData(this.pageConfig, this.jsonList);
    if (this.listConfigData?.columns && this.columnsToBeHidden && this.columnsToBeHidden.length > 0) {
      this.listConfigData.columns = this.getAuthorizedColumns(this.listConfigData.columns);
    }

    if (this.listConfigData?.columns) {
      this.restoreHeaderData = JSON.parse(JSON.stringify(this.listConfigData?.columns));
      if (this.from !== 'fun') {
        this.listButton = this.getAuthorizedButtons(this.listConfigData?.buttons);
      }
      this.setDefaultHeader();
      this.columnsDropdownOptions = this.getAvailableColumn();
      this.globalFilterfield = this.extractGlobalFilterField();
    }
  }

  getAuthorizedColumns(columns: RefrralHeaderType[]): RefrralHeaderType[] {
    return columns.filter(c => this.columnsToBeHidden.find(hc => hc === c.header_id) === undefined);
  }

  getAuthorizedButtons(buttons: ButtonConfig[]): ButtonConfig[] {
    return buttons?.filter(c => this.actionsToBeHidden.find(hc => hc === c.button_id) === undefined);
  }

  extractGlobalFilterField() {
    const fields = this.listConfigData.columns.filter((el: RefrralHeaderType) => el.isSearchable === 'y').
      map(res => res.jsonpath);
    return fields;
  }

  operatorChange(rule: any) {
    rule.disableValue = rule.filtertype && rule.filtertype === 'isempty';
  }

  updateFilterTypes(rule: any, force = true) {
    const contactTypes = ['email', 'mobile', 'altphone'];
    if (force) {
      rule.filtertype = '';
      rule.value = '';
      rule.customSearchType = '';
    }
    rule.filterTypes = [
      { label: 'Equal', value: 'Equal' },
      { label: 'Contains', value: 'contains' },
      { label: 'Not Equal', value: 'NOTEQUAL' },
      { label: 'Greater than', value: 'greaterthan' },
      { label: 'Less than', value: 'LESSTHAN' }
    ];
    if (!rule.column.toLowerCase().includes('date')) {
      rule.filterTypes.push(
        { label: 'Ends with', value: 'endsWith' },
        { label: 'Starts with', value: 'startswith' },
        { label: 'Greater than Equal To', value: 'GREATERTHANOREQUAL' },
        { label: 'Less than Equal To', value: 'LESSTHANOREQUAL' }
      );
    }
    if (rule.column.toLowerCase().includes('date')) {
      rule.filterTypes = rule.filterTypes.filter((type: any) => type.value !== 'contains');
    }
    if (contactTypes.includes(rule.column.toLowerCase())) {
      rule.filterTypes.unshift(
        { label: 'Is Blank', value: 'isempty' }
      );
    }
    if (rule?.column === 'application_submitted') {
      rule.filterTypes = [
        { label: 'Equal', value: 'Equal' }
      ]
    }
	if (rule?.column === 'associationType' || rule?.column === 'association_type') {
      if (this.jsonList === 'list_participant_enrollments' || this.jsonList === 'list_provider_enrollments') {
        // Consumer/provider lists: pick an association type from a dropdown. The value is the provider_type_lkp
        // code (AR, IR, ...); the backend derived filter matches it exactly against the record's associations
        // (operator is not used by derived columns, but Equal reflects the semantics).
        rule.customSearchType = 'dropdown';
        rule.filterTypes = [
          { label: 'Equal', value: 'Equal' }
        ];
      } else {
        rule.filterTypes = [
          { label: 'Equal', value: 'Equal' },
          { label: 'Contains', value: 'Contains' }
        ];
      }
    }
	if (rule?.column === 'DR Review Needed' || rule?.column === 'dr_review_needed') {
      rule.customSearchType = 'dropdown';
      rule.filterTypes = [
        { label: 'Equal', value: 'Equal' }
      ];
    }
    if (rule?.column === 'contact_status_reason_lkp' || rule?.column === 'isTSPastDue') {
      rule.customSearchType = 'dropdown';
      rule.filterTypes = [
        { label: 'Equal', value: 'Equal' }
      ]
    }
    if (rule?.column === 'daysSinceLastTimesheet') {
      // Preset day thresholds, compared "greater than" against days since the most recent submitted timesheet
      // (e.g. Greater than 90 = no submission in more than 90 days). Options supplied per list via
      // searchDropdownValuesByColumn.
      rule.customSearchType = 'dropdown';
      rule.filterTypes = [
        { label: 'Greater than', value: 'greaterthan' }
      ];
    }
    if (rule?.column === 'allTrainingComplete') {
      // Yes/No: whether the PA has completed all 5 required training modules.
      rule.customSearchType = 'dropdown';
      rule.filterTypes = [
        { label: 'Equal', value: 'Equal' }
      ]
    }
    if (rule?.column === 'authExpiringInDays') {
      // Preset 30/60/90-day window; the chosen value is the number of days for "auth expiring within X days"
      // (upcoming only). The backend derived column ignores the operator (its predicate is to_date between
      // today and today + X), so this label is display-only and reads as "expiring in less than X days".
      rule.customSearchType = 'dropdown';
      rule.filterTypes = [
        { label: 'Less than', value: 'LESSTHAN' }
      ]
    }
    if (rule?.column === 'mco_org_name' || rule?.column === 'ldssOffice'
      || rule?.column === 'application_source_lkp' && (this.jsonList === 'list_referrals' || this.jsonList === 'list_participant_enrollments')
    ) {
      rule.filterTypes = [
        { label: 'Equal', value: 'Equal' },
        { label: 'Contains', value: 'contains' }
      ];
    }
    if (rule?.column === 'associationStatus' || rule?.column === 'association_status') {
      rule.customSearchType = 'dropdown';
      rule.filterTypes = [
        { label: 'Contains', value: 'contains' }
      ];
    }
    if (rule?.column === 'application_status_lkp' && (this.jsonList === 'list_referrals' || this.jsonList === 'list_participant_enrollments')) {
      rule.customSearchType = 'dropdown';
      rule.filterTypes = [
        { label: 'Equal', value: 'Equal' }
      ];
    }
  }

  /**
   * Options for the value dropdown of a given rule. Per-column via searchDropdownValuesByColumn,
   * falling back to the shared searchDropdownValues (so existing single-dropdown pages still work).
   */
  getDropdownValues(rule: any): any[] {
    return this.searchDropdownValuesByColumn?.[rule?.column] ?? this.searchDropdownValues ?? [];
  }

  /**
   * Keeps a numeric custom-search value (e.g. "past X days") as a digits-only string so the value
   * stays a string (buildRequestPayload/validateFilterRules call .trim()) and the backend can safely
   * cast it into an interval.
   */
  onNumericInput(rule: any, event: any) {
    const cleaned = (event?.target?.value ?? '').toString().replace(/[^0-9]/g, '');
    rule.value = cleaned;
    if (event?.target) {
      event.target.value = cleaned;
    }
  }

  onCheckBoxHandler(event: any, rowData: any) {
    console.log(event);
    console.log(rowData);
  }


  getCounterOfDisplayNHeader() {
    this.filterRules.forEach(rule => {
      const matchingHeader = this.listConfigData.columns.find((header: RefrralHeaderType) =>
        header.jsonpath === rule.column
      )
      if (matchingHeader?.isDisplayedAtHeader == 'n') {

        this.countdisplay_N++;
      }
    })
  }

  sendSMS() {
    this.showSMSModal = 'sms'
  }

  onHandleCancel(event: any) {
    this.showSMSModal = event;
  }

  addRule() {
    if (this.filterRules.length < 8) {
      if ((this.jsonList == 'list_participant_enrollments'
        || this.jsonList == 'list_global_consumer_search')
        && this.filterRules.length == 0) {
        this.filterRules.push({ column: 'participant_ppl_id', filtertype: 'Equal', value: '', isApplied: false });
        this.updateFilterTypes(this.filterRules[0], false);
      }
      else if (this.jsonList == 'list_provider_enrollments' && this.filterRules.length == 0) {
        this.filterRules.push({ column: 'ppl_provider_id', filtertype: 'Equal', value: '', isApplied: false });
        this.updateFilterTypes(this.filterRules[0], false);
      }
      else if (this.jsonList == 'list_authorizations' && this.filterRules.length == 0) {
        this.filterRules.push({ column: 'consumerPPLId', filtertype: 'Equal', value: '', isApplied: false });
        this.updateFilterTypes(this.filterRules[0], false);
      }
      else if (this.jsonList === 'list_file_upload_notification' && this.filterRules.length == 0) {
        this.filterRules.push({ column: 'pplId', filtertype: 'Equal', value: '', isApplied: false });
        this.updateFilterTypes(this.filterRules[0], false);
      }
      else {
        this.filterRules.push({ column: '', filtertype: '', value: '', isApplied: false });
      }
    }
  }

  removeRule(index: number) {
    if (this.filterRules.length > 1) {
      this.filterRules.splice(index, 1);
    }
  }

  getAvailableColumnForSort() {
    return this.listConfigData?.columns?.filter(header => header.isSearchable === 'y');
  }

  getAvailableColumn() {
    return this.listConfigData?.columns
      ?.filter(header => header.isSearchable === 'y')
      .map(header =>
        header.header_id.toLowerCase().includes('date')
          ? { ...header, header_label: `${header.header_label} (in MM/DD/YYYY)` }
          : header
      );
  }

  getAvailableColumnsByFilter(index: number) {
    const selectedColumnFilterSet = new Set(Object.values(this.selectedColumnFilters));
    const currentSelection = this.selectedColumnFilters[index];
    const selectedColumn = this.filterRules.map((filter, i) => i === index ? filter.column : '');
    if (!currentSelection && selectedColumn && selectedColumn.length > 0 && selectedColumn[index] && !selectedColumnFilterSet.has(selectedColumn[index])) {
      this.selectedColumnFilters[index] = selectedColumn[index].toString();
    }
    const transfromData = this.listConfigData?.columns?.filter(header => header.isSearchable === 'y' && (!selectedColumnFilterSet.has(header.jsonpath) || header.jsonpath === currentSelection));
    return transfromData;
  }

  setDefaultHeader() {
    let count = 1;
    this.filterHeaders = [];
    this.filterHeaders = this.listConfigData.columns.filter((header: RefrralHeaderType) => header.isDisplayedAtHeader === 'y');
    this.filterRules.forEach((filter: FilterRuleType) => {
      const header = this.listConfigData.columns.find((h: RefrralHeaderType) => h.jsonpath === filter.column);
      if (header && header.isDisplayedAtHeader == 'n' && count < 4) {
        count++;
        this.filterHeaders.push(header);
      }
    })

    this.cols = this.filterHeaders?.map((el: RefrralHeaderType) => {
      return { field: el.jsonpath, header: el.header_label }
    })

  }

  gridActionClicked(btn: any, item: any, params: any = null) {
    this.gridAction.emit({ "action": btn, "data": item, "param": params });
  }

  keyPressed(event: KeyboardEvent, rowData: any, col?: any) {
    if (event && (event.key === 'Enter' || event.key === ' ')) {
      this.rowClicked(rowData, col);
    }
  }

  actionType(type: string){
    this.paystubActionType = type;
  }

  rowClicked(event: any, col?: any) {
    if (col?.isClickable && event
      && (col?.field?.toLowerCase().indexOf('pplid') > -1 || col?.field?.toLowerCase().indexOf('ppl_id') > -1)) {
      const pplID = event[col?.field];
      const isConsumer = pplID?.startsWith("PRC")
      this.userService.setViewUserEvent({
        field: col?.field,
        value: pplID,
        isConsumer: isConsumer,
        userId: isConsumer ? (event.consumerId ?? event.participantId) : event.providerId,
      });
      return;
    }

    if ((col?.field === 'processingStatus' && (['View', 'Pended'].includes(event.processingStatus) || CommonUtil.hasInfoStatus(event.processingStatus)))
      || ((col?.field === 'businessStatus' || col?.field === 'status') && ['D', 'P', 'AC', 'RP', 'STE', 'PPP', 'P'].includes(event.businessStatusLkp))
      || (col?.field === 'authNum' && event?.authNum === 'View')
      || (col?.field === 'status' && event.status && this.from === 'claimAdj')
      || (col?.field === 'batchFileId' && event.batchFileId && this.from === 'claimAdj')
      || col?.field === 'ignoredTimesheetCount' && event.ignoredTimesheetCount
      || col?.field === 'patientName' && event.patientName
      || col?.field === 'resubFlg' && event.resubFlg
      || col?.field === 'lkpDomainId' && event.lkpDomainId
      || col?.field === 'lkpValueId' && event.lkpValueId
      || col?.field === 'pplIcn' && event.claimFamilyId !== undefined && event.claimId) {
      this.rowDetailEventTs.emit({ event, col });
      return;
    }
    else if((col?.field === 'chequeNumber' && event.chequeNumber != null)){
      this.rowDetailEventTs.emit({ event, col, type: this.paystubActionType });
      return;
    }
    else {
      this.rowDetailEvent.emit(event);
    }
  }

  rowLinkClicked(event: MouseEvent) {
    // first column receives <a href="#"> tag for accessibility
    event.preventDefault();
    // click events bubble up to this.rowClicked
  }

  clearNotApplicableFilterRules() {
    this.filterRules = this.filterRules?.filter(e => e.isApplied);
    if (this.filterRules.length == 0) {
      this.addRule();
    }

    if (!this.isFilterApplied) {
      this.sortBy = '';
      this.columnName = '';
      this.condition = 'and';
    }
  }

  showDetails(rowData: any) {
    this.showAuthDetails.emit(rowData);
  }

  calculatePagination(startingPageNumber: number, recordsPerPage = 20) {
    this.lastLoadedPage = startingPageNumber;

    if (this.filteredData.length > 0) {
      this.recordsPerPage = recordsPerPage;
      this.nextRefreshPage = Math.floor((startingPageNumber - 1) / 5) * 5 + 6;

      if (this.listData?.length % 100 !== 0) {
        this.totalRecords = this.listData?.length;
      } else {
        this.totalRecords = this.data?.length && !this.customDataLoaded ? this.listData?.length : this.listData?.length + 1;
      }
    } else {
      this.totalRecords = 0;
    }

    //update the UI
    this.changeDetectRef.detectChanges();
  }

  refetchDataAfterUpdate(
    payload: ListGridRequestPayload,
    event?: any
  ) {
    this.loadDataFromAPI(payload, event, true);
  }

  loadDataFromAPI(
    payload: ListGridRequestPayload,
    event?: any,
    hasUpdatedEntry?: boolean,
  ) {
    this.listService.getListData(payload, this.from, hasUpdatedEntry).subscribe((data: any) => {
      console.log("Data", data);
      if (data?.responsemsg[0]?.code !== 'INTERNAL_SERVER_ERROR') {
        this.normalizeDaysSinceLastTimesheet(data.responsedata);
        if (this.isFilterApplied && String(payload?.startingPageNumber) === '1') {
          this.listData = [...data.responsedata];

          if (this.sharedDataKey) {
            this.sharedDataService.setData(this.sharedDataKey, this.generateFilterObject(this.filterRules, this.columnName, this.sortBy, this.condition));
          }
        } else {
          if (parseInt(payload?.startingPageNumber + '') === 1) {
            this.listData = [];
          }
          this.listData = ([...this.listData, ...data.responsedata]);
        }
        this.setFilterData(this.listData, event?.first ?? 0);
        this.calculatePagination(payload.startingPageNumber);
        this.resetTableSortingState();
      }
    });
  }

  resetPagination(startingPageNumber: any, currentPage: any) {
    this.setFilterData(this.listData, currentPage);
    this.calculatePagination(startingPageNumber);
    this.resetTableSortingState();
  }

  resetTableSortingState() {
    this.dt.sortOrder = 0;
    this.dt.sortField = null;
    this.dt.tableService.onSort(null);
  }

  setFilterData(data: any, recordsFrom: number) {
    this.filteredData = [...data.slice(recordsFrom, recordsFrom + this.recordsPerPage)];
  }

  /**
   * The backend uses 99999 as the "never submitted a timesheet" sentinel so those rows still match a
   * "days since last timesheet > X" filter. Blank it out (null renders as '-') so the UI doesn't show 99999,
   * while keeping the row in the results.
   */
  private normalizeDaysSinceLastTimesheet(rows: any[]) {
    rows?.forEach(row => {
      if (row && (row.daysSinceLastTimesheet === '99999' || row.daysSinceLastTimesheet === 99999)) {
        row.daysSinceLastTimesheet = null;
      }
    });
  }

  validateFilterRules(): boolean {
    this.showSortByError = false;
    this.filterRules.forEach(e => {
      if (e.filtertype !== 'isempty' && (e.column === '' || e.column === null || e.filtertype === '' || e.filtertype === null || e.value === '' || e.value.trim() === '')) {
        this.filterError = 'Please fix filter errors and proceed ';
        return;
      }
    });

    if (this.columnName && this.columnName.length > 0 && !this.sortBy) {
      this.showSortByError = true;
      this.filterError = 'Please Select Sort By';
    }

    return this.filterError ? true : false;
  }

  applyFilter() {
    this.isFilterApplied = false;
    this.filterError = '';
    /*  this.buildRequestPayload(); */
    if (this.validateFilterRules()) {
      return;
    }
    this.setDefaultHeader();
    this.show = false; // updated to new modal
    /* this.overlayPanel.hide(); */
    const payload = this.buildRequestPayload();
    if (this.filterRules.length > 0 && this.filterRules[0].column == '') {
      payload.searchParam = []
    }
    if (this.isFilterApplicable(payload.searchParam)) {
      this.isFilterApplied = true;
      this.filterRules?.forEach(e => {
        e.isApplied = true;
      });
    }

    if (String(payload.startingPageNumber) === '1') {
      this.first = 0;
      this.currentUIPage = 1;
    }

    this.loadDataFromAPI(payload);
  }

  private buildRequestPayload(event?: any) {
    const oderByColumn = this.listConfigData && this.listConfigData.orderByColumn ? this.listConfigData.orderByColumn : [];
    const orderBy = this.listConfigData && this.listConfigData.orderBy ? this.listConfigData.orderBy : [];
    const payload: ListGridRequestPayload = {
      pageName: this.listConfigData?.pageName,
      programCode: this.selectedProgram?.program_code,
      condition: this.condition ? this.condition : '',
      recordsPerPage: 20,
      //sortby : this.sortBy,
      startingPageNumber: event ? (event?.startingPageNumber).toString() : '1',
      searchParam: [],
      orderByColumn: this.columnName ? [this.columnName, ...oderByColumn] : oderByColumn,
      orderBy: this.sortBy ? [this.sortBy, ...orderBy] : orderBy,
    }
    payload.searchParam = this.filterRules?.filter(e =>
      (e.filtertype === 'isempty' || (e.column != '' && e.filtertype != '' && e.value != '' && e.value.trim() != ''))
    ).map((el: FilterRuleType) => {
      return { jsonPath: el.column, value: el.value.trim(), operator: el.filtertype }
    });
    return payload;
  }

  clearAllFilters() {
    if (this.jsonList == 'list_participant_enrollments' || this.jsonList == 'list_global_consumer_search'
      || this.jsonList == 'list_referrals' || this.jsonList == 'list_provider_enrollments' || this.jsonList == 'list_authorizations' || this.jsonList == 'list_file_upload_notification') {
      this.filterRules = [];
      this.addRule();
    } else {
      this.filterRules = [{
        column: '',
        filtertype: '',
        value: '',
        isApplied: false
      }];
    }
    this.sortBy = '';
    this.columnName = '';
    this.selectedColumnFilters = {};
    this.condition = 'and';
    if (this.sharedDataKey) {
      this.sharedDataService.clearData(this.sharedDataKey);
    }
  }

  onCancel() {
    /* this.overlayPanel.hide(); */
    this.show = false; // updated to new modal
    this.gridTextSearchFilter = '';
    const payload = this.buildRequestPayload();
    payload.searchParam = [];
    payload.orderByColumn = this.listConfigData.orderByColumn;
    payload.orderBy = this.listConfigData.orderBy
    this.isFilterApplied = false;
    this.selectedCheckBoxValue = [];
    this.clearAllFilters();
    this.loadDataFromAPI(payload);
    this.dt.reset();
  }

  // sendNotification(type: string) {
  //   const values = this.selectedCheckBoxValue;
  //   this.listService.setApplicationData(values);
  //   this.notificationType = type == 'sms' ? 'mobile number' : 'email address';
  //   if (!values.length) {
  //     const errorMessage = `Please select a record to proceed with this action.`;
  //     this.errorAlertService.openModal('error', 'Error', errorMessage, '');
  //   } else {
  //     this.showSMSModal = 'sms';
  //   }
  // }

  loadRecords(event?: any) {
    const page = Math.floor(event.first / event.rows) + 1;
    this.currentUIPage = page;
    if (this.data?.length > 0 || this.isLoadedDataFromSharedService || this.disableSort) {
      const start = event?.first ?? 0;
      const end = ((event?.first ?? 0) + this.recordsPerPage);
      const records = this.data && this.data.length ? this.data.slice(start, end) : [];
      if (records.length > 0) {
        this.listData = [...this.data];
        this.setFilterData(this.listData, event?.first ?? 0);
        this.calculatePagination(page, this.recordsPerPage);
        //this.resetTableSortingState();
        return;
      }
    }

    const apiTriggerPage = page >= this.nextRefreshPage;
    if (apiTriggerPage) {
      event = { ...event, startingPageNumber: page };
      if (this.customDataLoaded) {
        this.onPageLoad.emit(event);
      } else {
        const payLoad = this.buildRequestPayload(event);
        if (payLoad?.pageName) {
          this.loadDataFromAPI(payLoad, event);
        }
      }
    } else {

      let resData: any[] = []
      if (this.gridTextSearchFilter.length === 0) {
        resData = [...this.listData]
      } else {
        resData = [...this.gridSearchData];
      }
      if (resData.length > 0) {
        this.setFilterData(resData, event.first);
        this.changeDetectRef.detectChanges();
      }
    }

  }

  sortByColumn(event: any) {
    const sortData = (data: any) => {
      data.sort((a: any, b: any) => {
        const valueA = a[event.field]?.toLowerCase() ? a[event.field]?.toLowerCase() : a[event.field];
        const valueB = b[event.field]?.toLowerCase() ? b[event.field]?.toLowerCase() : b[event.field];

        const isValue1Empty = valueA === null || valueA === '';
        const isValue2Empty = valueB === null || valueB === '';
        if (isValue1Empty && isValue2Empty) return 0; //both values are empty
        if (isValue1Empty) return 1; //place empty values at the end
        if (isValue2Empty) return -1; //place empty values at the end

        let result;
        if (Date.parse(valueA) && Date.parse(valueB)) {
          const dateA = new Date(valueA);
          const dateB = new Date(valueB);
          result = dateA < dateB ? -1 : dateA > dateB ? 1 : 0;
        }
        else {
          result = valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
        }
        return event.order === 1 ? result : -result;
      })
    }

    if (event.field) {
      sortData(this.listData);
    }

    if (this.gridTextSearchFilter.length > 0) {
      sortData(this.gridSearchData);
      return this.filteredData = [...this.gridSearchData]
    }

    return this.filteredData = [...this.listData]
  }


  onColumnFilter(event: any) {
    let filtered: any[] = [...this.listData];
    if (event.filters) {
      Object.keys(event.filters).forEach(key => {
        const filterValue = event.filters![key][0].value?.toLowerCase();
        const matchMode = event.filters![key][0].matchMode || 'contains';
        if (filterValue) {
          filtered = filtered.filter((item: any) => {

            const itemValue = item[key]?.toString().toLowerCase();
            switch (matchMode) {
              case 'startsWith':
                return itemValue.startsWith(filterValue);

              case 'contains':
                return itemValue.includes(filterValue);

              case 'notContains':
                return !itemValue.includes(filterValue)

              case 'endsWith':
                return itemValue.endsWith(filterValue);

              case 'equals':
                return itemValue === filterValue;

              case 'notEquals':
                return itemValue !== filterValue

              default: return true

            }
          })
        }
      });
    }

    return this.filteredData = [...filtered];

  }

  onSearch(event: any) {
    const searchKey = event?.trim();
    this.gridSearchData = [...this.listData];

    if (searchKey?.length > 0) {
      this.gridSearchData = this.gridSearchData.filter(item => {
        return this.cols.some(field =>
          item[field.field]?.toString()?.toLowerCase()?.includes(searchKey.toLowerCase())
        );
      });
    }

    this.totalRecords = this.gridSearchData.length;
    return this.filteredData = [...this.gridSearchData];
  }

  selectAll(event: any) {
    const filtered: any[] = [...this.listData];
    this.selectedRow = filtered.map(data => {
      const selected = { ...data, isSelected: event.checked }
      return selected
    });
    return this.selectedRow;
  }

  isFilterApplicable(searchParams: SearchParams[]) {
    if (searchParams.length > 0 || (this.columnName && this.sortBy)) {
      return true;
    }

    return false;
  }

  generateFilterObject(filterRules: FilterRuleType[], columnName: string, sortBy: string, condition: string): any {
    return {
      filterRules: filterRules,
      columnName: columnName,
      sortBy: sortBy,
      condition: condition,
    };
  }

  reloadDataFromSharedService(appliedFilters: any) {
    this.filterRules = appliedFilters.filterRules;
    this.columnName = appliedFilters.columnName;
    this.sortBy = appliedFilters.sortBy;
    this.condition = appliedFilters.condition;
    this.isFilterApplied = true;
    const payload = this.buildRequestPayload();
    this.loadDataFromAPI(payload);
  }

  getErrorStatus(hasError: boolean) {
    return hasError ? 'error' : ''
  }

  isActiveStatus(rowData: any, col: any) {
    if (!col.field) {
      return false;
    }

    if (col.isClickable) {
      return true;
    }

    if ((col.field == 'Auth Number' || col.field == 'authNum') && rowData[col.field] == 'View') {
      return true;
    }

    if (col.field == 'processingStatus' || col.field == 'processStatus') {
      return ['Pended'].includes(rowData[col.field]) || CommonUtil.hasInfoStatus(rowData[col.field]);
    }

    return false;
  }

  validateFieldHasValue(fieldValue: any) {
    return fieldValue === '' || fieldValue === ' '
      || fieldValue === null || fieldValue === undefined
      || (Array.isArray(fieldValue) && fieldValue.length < 1) ? false : true;
  }

  isClickableField(rowData: any, col: any): boolean {
    const field = col.field;
    const value = rowData[field];

    const isDeniedStatus =
      value === 'Denied' &&
      (field === 'businessStatus' || field === 'status') &&
      this.timesheetFor !== 'staff';

    const clickableInBilling =
      this.from === 'billing' && this.isClickableInBilling(rowData, field);

    const clickableInReport =
      this.from === 'reports' && this.isClickableInReport(rowData, field);

    const activeStatus = this.isActiveStatus(rowData, col);

    const fieldHasValue = this.validateFieldHasValue(value);

    return (activeStatus || isDeniedStatus || clickableInBilling || clickableInReport) && fieldHasValue;
  }

  exportAllCSV() {
    if (!this.loadPage || this.customDataLoaded || !this.listConfigData?.pageName) {
      const backup = this.filteredData;
      this.filteredData = [...this.data];
      this.changeDetectRef.detectChanges();
      this.dt.exportCSV();
      this.filteredData = backup;
      this.changeDetectRef.detectChanges();
      return;
    }

    const calls = Array.from({ length: 5 }, (_, i) => {
      const payload = this.buildRequestPayload();
      payload.startingPageNumber = this.currentUIPage + (i * 5);
      payload.recordsPerPage = 20;
      return this.listService.getListData(payload, this.from);
    });

    forkJoin(calls).subscribe((results) => {
      const allRecords = results
        .filter((data) => data?.responsemsg[0]?.code !== 'INTERNAL_SERVER_ERROR')
        .flatMap((data) => data.responsedata);

      if (allRecords.length > 0) {
        const backup = this.filteredData;
        this.filteredData = [...allRecords];
        this.changeDetectRef.detectChanges();
        this.dt.exportCSV();
        this.filteredData = backup;
        this.changeDetectRef.detectChanges();
      }
    });
  }

  getCellStyles(rowData: any, col: any): { [klass: string]: any } {
    const field = col.field;
    const value = rowData[field];

    const isDeniedStatus =
      value === 'Denied' &&
      (field === 'businessStatus' || field === 'status') &&
      this.timesheetFor !== 'staff';

    const clickableInBilling =
      this.from === 'billing' && this.isClickableInBilling(rowData, field);

    const clickableInReport =
      this.from === 'reports' && this.isClickableInReport(rowData, field);

    const activeStatus = this.isActiveStatus(rowData, col);

    const isClickable = activeStatus || isDeniedStatus || clickableInBilling || clickableInReport;

    return {
      color: isClickable ? 'blue' : 'inherit',
      'text-decoration': activeStatus || isDeniedStatus ? 'underline' : 'none',
      cursor: isClickable ? 'pointer' : 'default',
    };
  }
}